import * as React from 'react';
import RequiredLabel from './RequiredLabel';

interface Props {
	className?: string;
	style?: {};
	children?: {};
	required?: boolean;
	htmlFor?: string;
}

const Label: React.StatelessComponent<Props> = props => {
	return (
		<label className={props.className} htmlFor={props.htmlFor}>
			{props.children && (
				<span 
					className={`label-title${props.required ? ' label-title-required' : ''}`} 
					dangerouslySetInnerHTML={{ __html: props.children as any }}
				/>
			)}
			{props.required && <RequiredLabel>Required</RequiredLabel>}
		</label>
	);
};

export default Label;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/Label.tsx